import { useRef, useState, useEffect } from "react";
import { CustomModal, FooterActivities, InteractiveVideo, IsLoading, LessonForm, Timeline } from '../components';
import { useNavigate, useParams } from "react-router-dom";
import { MdDelete, MdEdit, MdGrade, MdTopic } from "react-icons/md";
import { Switch } from '@headlessui/react'
import { DocumentTitle, encryptHref, getGrades, getSubjects } from "../utils";
import { FaCopy, FaEye, FaPlay, FaPlus, FaShare, FaCopyright, FaCalendarDay } from "react-icons/fa";

import toast, { Toaster } from 'react-hot-toast';
import { CgSmartphoneChip } from "react-icons/cg";
import LoadingRobot from "../assets/robot.gif"



// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_URL } from "../constants";
import Swal from "sweetalert2";
import CopyCourseMaterial from "../components/CopyCourseMaterial";
import PublishModal from "../components/PublishModal";


function LessonDetails({ passedId, initialConstants }) {
  const user = useSelector(state => state.user.details);
  // const { id } = useParams();
  const myParams = useParams();
  const { id } = myParams;
  // console.log("myParams");
  // console.log(myParams);
  const [modal, setModal] = useState({ open: false });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const videoRef = useRef(null);
  const [questions, setQuestions] = useState([]);
  const [lesson, setLesson] = useState(null);
  DocumentTitle(`IVY | Lessons ${lesson && `| ${lesson.title}`}`);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isToggle, setIsToggle] = useState(true);
  const [fullStyle, setFullStyle] = useState({});
  const [hitQuestion, setHitQuestion] = useState(false);
  const [question, setQuestion] = useState(null);
  const [currentQuestionTime, setCurrentQuestionTime] = useState(0);
  const [interactiveMode, setInteractiveMode] = useState(false);
  const [analysisMode, setAnalysisMode] = useState(false);
  const [constants, setConstants] = useState(initialConstants || []);
  const lessonsview = window.location.href.includes("lessonsview");
  const [onProgressEvents, setOnProgressEvents] = useState([]);
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const [onReadyEvents, setOnReadyEvents] = useState([]);
  const [volume, setVolume] = useState(1);
  const [lastHitTime, setLastHitTime] = useState(0);
  const [isStudentSelfLearningMode, setIsStudentSelfLearningMode] = useState(window.location.href.includes("lessonsviewsl"))
  const [questionStylesInisStudentSelfLearningMode, setQuestionStylesInisStudentSelfLearningMode] = useState({});
  // const [count, setCount] = useState(0);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (count < 5) {
  //       setCount(prevCount => prevCount + 1);
  //     } else {
  //       clearInterval(intervalId);
  //     }
  //   }, 1000); // Interval of 1 second

  //   // Cleanup function to clear interval when component unmounts
  //   return () => clearInterval(intervalId);
  // }, [count]); // Re-run effect when count changes

  const handleEdit = async () => {
    setModal({ open: true, mode: 'edit' });
  }

  const handleDelete = async () => {
    setModal({ open: true, mode: 'delete' });
  }

  const closeModal = async () => {
    setModal({ open: false });
  }

  const updateLesson = async (formData) => {
    setLoading(true);

    try {
      const res = await axios.put(`${BASE_URL}/lesson/updateLesson.php?lessonId=${id}`, formData);
      setLoading(false);
      const resObject = await res.data;

      if (res.status == 200) {
        closeModal();
        setLesson(resObject.data);
      }

    } catch (error) {
      console.log(error);
    }
  }

  const deleteLesson = async () => {
    setLoading(true);

    try {
      const res = await axios.delete(`${BASE_URL}/lesson/deleteLesson.php?lessonId=${id}`);
      setLoading(false);

      if (res.status == 200) {
        closeModal();
        navigate(`/dashboard/lesson/library`);
      }

    } catch (error) {
      if (error.response.data.msg) {
        setLoading(false);
        closeModal();
        Swal.fire({
          icon: "error",
          title: "Not Allowed",
          text: error.response.data.msg,
        });
      } else {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/lesson/questions.php?lessonId=${passedId || id}`);
        const data = await res.data;

        if (res.status == 200) {
          if(data === undefined || data === null) {
            setQuestions([]);
          }else{
            setQuestions(data);

          }
        }

      } catch (error) {
        console.log('Error fetching questions:', error);
      }
    };

    const fetchLessonDetails = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/lesson/index.php?id=${passedId || id}`);
        const resObject = await res.data;
        if (res.status == 200) {
          setLesson(resObject.data);
          if ((!isStudentSelfLearningMode) && id && (user.roleId == 1 || user.roleId == 2)) {
            setAnalysisMode(true);
          }
          fetchQuestions();
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchLessonDetails();
  }, [id]);

  useEffect(() => {
    const getConstants = async () => {
      const Grades = await getGrades();
      const Subjects = await getSubjects();

      setConstants({ Grades, Subjects });
    }

    constants.length == 0 && getConstants();
  }, [])

  useEffect(() => {
    const publishLesson = async () => {
      try {
        const res = await axios.put(`${BASE_URL}/lesson/publishLesson.php?lessonId=${id}`);
        const resObject = res.data;

        if (resObject.status == 200) {
          setLesson(resObject.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (user.roleId == 822110 && lesson?.published == 0) {
      publishLesson();
    }
  }, [lesson?.published])


  const handlePublish = (targetId) => {
    setModal({ open: true, mode: 'publish', targetId })
    // console.log("publish");
  }


  if (!lesson) return <IsLoading />

  return <div
    style={{
      width: "100%",
      height: "100%",
      // minHeight: "70vh",
      margin: 0,
      // padding: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "13px",
    }}
    className={` flex-wrap flex-md-nowrap   ${id && !lessonsview && "pb-3 pb-md-0"} `}
  // className={`${id && !lessonsview && 'w-full flex max-lg:flex-col gap-4 justify-between max-w-7xl page-container'} ${lessonsview && 'h-screen w-fit mx-auto'}`}
  >
    <div className={`interactive-video h-full w-3/4  ${id && !lessonsview && 'shadow-lg border-[1px] border-gray-400'}`}>
      <div className='upper-content relative'>
        {
          id && (interactiveMode || user.roleId == 1 || user.roleId == 2) &&
          <div className="absolute inset-y-0 left-2 flex items-center">
            <select
              name="mode"
              className="rounded-lg bg-gray-50 px-2 py-1 shadow border-[1px] border-gray-400 text-sm"
              id="mode"
              onChange={(e) => {
                const value = (e.target.value) - 0;
                setIsStudentSelfLearningMode(4 === value)
                setAnalysisMode(3 === value)
                setInteractiveMode(2 === value)
              }}
            >
              {
                (user.roleId == 1 || user.roleId == 2) &&
                <option
                  value="1"
                >
                  Student ( In Class ) Mode
                </option>
              }

              {
                (user.roleId == 1 || user.roleId == 2) &&
                <option
                  value="4"
                  selected={isStudentSelfLearningMode}
                >
                  Student ( Self Learning ) Mode
                </option>
              }

              {
                (user.roleId == 1 || user.roleId == 2) &&
                <option
                  value="3"
                  selected={analysisMode}
                >
                  Live Participation
                </option>
              }
              {
                ((lesson.user_id == user.userId) || user.roleId == 1) &&
                <option
                  value="2"
                  selected={interactiveMode}
                >
                  Edit Mode
                </option>
              }

            </select>

          </div>
        }

        <h1 className="text-2xl font-semibold text-gray-200 m-0 capitalize">{lesson.title}</h1>
        {
          user.userId == lesson.user_id && !window.location.href.includes("lessonsview") && !passedId &&
          <div className="absolute inset-y-0 right-1 flex items-center">
            <button onClick={handleEdit} className="edit"><MdEdit fontSize={20} /></button>
            <button onClick={handleDelete} className="delete"><MdDelete fontSize={20} /></button>
          </div>
        }

        <CustomModal open={modal.open} handleClose={closeModal}>
          {
            modal.mode == 'edit' &&
            <LessonForm lesson={lesson} handleFormAction={updateLesson} loading={loading} />
          }

          {
            modal.mode == 'delete' &&
            <div className="flex flex-col gap-4 px-4 py-8">
              <div className="flex flex-wrap gap-1 text-xl font-semibold justify-center">
                Are you sure you want to delete
                <span className="text-red-600 font-bold">{lesson.title}</span>
                lesson ?
              </div>

              <button type="button" disabled={loading} className="delete-button w-full md:w-1/2 mx-auto" onClick={deleteLesson}>Delete Lesson</button>
            </div>
          }

          {
            modal.mode == 'publish' && (
              <PublishModal
                // value={`${window.location.origin}/lessonsview/${modal.targetId}`}
                callback_onclick={() => { navigator.clipboard.writeText(document.getElementById('publish_link').value); toast.success("Link copied to clipboard!") }}
                title={lesson.title}
                closeModal={() => { closeModal() }}
                targetId={modal.targetId}
              />
            )
          }

        </CustomModal>
      </div>


      <InteractiveVideo
        style={fullStyle}
        videoRef={videoRef}
        questions={questions}
        setQuestions={setQuestions}
        videoUrl={lesson.lurl || lesson.murl}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        isToggle={isToggle}
        setFullStyle={setFullStyle}
        hitQuestion={hitQuestion}
        setHitQuestion={setHitQuestion}
        question={question}
        setQuestion={setQuestion}
        interactiveMode={interactiveMode}
        analysisMode={analysisMode}
        currentQuestionTime={currentQuestionTime}
        setCurrentQuestionTime={setCurrentQuestionTime}
        onProgressEvents={onProgressEvents}
        setOnProgressEvents={setOnProgressEvents}
        onReadyEvents={onReadyEvents}
        setOnReadyEvents={setOnReadyEvents}
        volume={volume}
        setVolume={setVolume}
        mediaLoaded={mediaLoaded}
        lastHitTime={lastHitTime}
        setLastHitTime={setLastHitTime}
        isStudentSelfLearningMode={isStudentSelfLearningMode}
        questionStylesInisStudentSelfLearningMode={questionStylesInisStudentSelfLearningMode}
        setQuestionStylesInisStudentSelfLearningMode={setQuestionStylesInisStudentSelfLearningMode}
      />

      {
        videoRef &&
        <Timeline
          questionStylesInisStudentSelfLearningMode={questionStylesInisStudentSelfLearningMode}
          isStudentSelfLearningMode={isStudentSelfLearningMode}
          videoRef={videoRef}
          questions={questions}
          setQuestions={setQuestions}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          isToggle={isToggle}
          setIsToggle={setIsToggle}
          setFullStyle={setFullStyle}
          hitQuestion={hitQuestion}
          setHitQuestion={setHitQuestion}
          question={question}
          setQuestion={setQuestion}
          setCurrentQuestionTime={setCurrentQuestionTime}
          currentQuestionTime={currentQuestionTime}
          interactiveMode={interactiveMode}
          onProgressEvents={onProgressEvents}
          setOnProgressEvents={setOnProgressEvents}
          onReadyEvents={onReadyEvents}
          setOnReadyEvents={setOnReadyEvents}
          volume={volume}
          setVolume={setVolume}
          setLastHitTime={setLastHitTime}
          mediaLoaded={mediaLoaded}
          setMediaLoaded={setMediaLoaded}
        />
      }

      {
        videoRef && interactiveMode &&
        <FooterActivities
          question={question} setQuestion={setQuestion}
          videoRef={videoRef}
          questions={questions} setQuestions={setQuestions}
          setIsPlaying={setIsPlaying}
          setFullStyle={setFullStyle}
          hitQuestion={hitQuestion} setHitQuestion={setHitQuestion}
          interactiveMode={interactiveMode}
          onProgressEvents={onProgressEvents} setOnProgressEvents={setOnProgressEvents}
        />
      }
    </div>

    {
      id && !lessonsview && (user.roleId == 1 || user.roleId == 2) &&
      <div className="flex flex-col gap-2 w-full lg:w-1/4 bg-gray-50 rounded-lg px-4 py-8 shadow-lg border-[1px] border-gray-400">

        {
          (!lessonsview) &&
          (user.userId == lesson.user_id || user.roleId == 1) &&
          <button className="outline-button w-full" onClick={async () => handlePublish(await encryptHref(lesson.id))}>
            <FaShare />
            Publish
          </button>
        }


        <div className="flex flex-col gap-2 w-full mb-4">
          <h1 className='m-0 text-2xl'>Description</h1>
          <p className="m-0">{lesson.description}</p>
        </div>

        <div className="flex items-center gap-1 w-full text-green-500 text-lg">
          <MdGrade fontSize={20} />
          <span className="font-semibold">{constants.Grades?.filter(grade => grade.id == lesson.grade_id)[0]?.grade}</span>
        </div>

        <div className="flex items-center gap-1 w-full text-yellow-500 text-lg">
          <MdTopic fontSize={20} />
          <span className="font-semibold">{constants.Subjects?.filter(subject => subject.id == lesson.subject_id)[0]?.title}</span>
        </div>
      </div>
    }
  </div>
}
export default LessonDetails;
